import React, { useEffect, useState } from 'react';

type ToggleProps = {
    value: boolean;
    onToggle: (value: boolean) => void;
    width?: number;
    height?: number;
};

export const Toggle: React.FC<ToggleProps> = ({ value, onToggle, width, height }) => {
    const [isOn, setIsOn] = useState(value);

    const handleToggle = () => {
        const next = !isOn;
        setIsOn(next);
        onToggle(next);
    };

    useEffect(() => {
        setIsOn(value);
    }, [value]);

    return (
        <div
            style={{ width: width || '50px', height: height || '28px' }}
            className={`w-[51px] h-[28px] rounded-full p-[2px] flex items-center cursor-pointer transition-colors duration-300 ${
                isOn ? 'bg-[#27B98D]' : 'bg-[#D4D4D4]'
            }`}
            onClick={handleToggle}
        >
            <div
                className={`w-[20px] h-[20px] rounded-full bg-white shadow-md transition-transform duration-300 transform ${
                    isOn ? 'translate-x-[26px]' : 'translate-x-0'
                }`}
            />
        </div>
    );
};
